export default __webpack_public_path__ + "static/media/GummyBearz.a3ef63ae.mp3";